import React from "react";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/context/LanguageContext";

/* Language selector. `light` renders white text for the transparent hero navbar. */
export const LanguageSwitcher = ({ light = false, className = "" }) => {
  const { locale, locales, setLocale } = useLanguage();
  const current = locales.find((l) => l.code === locale) || locales[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          aria-label="Change language"
          className={`flex items-center gap-1.5 text-sm font-medium transition-colors ${
            light ? "text-white/90 hover:text-white" : "text-foreground/80 hover:text-foreground"
          } ${className}`}
        >
          <Globe className="h-4 w-4" />
          <span className="uppercase tracking-wide">{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {locales.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLocale(l.code)}
            data-testid={`language-option-${l.code}`}
            className="flex items-center justify-between"
          >
            <span>{l.native}</span>
            {l.code === locale && <Check className="h-4 w-4 text-[var(--lux-seaglass)]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
